import { Box, Drawer as DrawerChakra, DrawerOverlay, DrawerContent, Text, DrawerBody } from '@chakra-ui/react';
import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { styles } from '../../styles';
import { IDrawer } from './interface';
import { useAuthContext } from '@contexts/auth.context';
import { ROUTES } from 'src/config/routes';
import { User, UserType } from '@models/User';
import { StorageManager } from '@storage/index';
import { IOptions } from './interface';
import { Student as studentOptions, Teacher as teacherOptions } from './options';
import { TeacherProps } from '@models/Teacher';

const options = (user: User | TeacherProps): IOptions[] => {
	if (user?.ENTRARCOMO === UserType.PROFESSOR) {
		const currUser = user as TeacherProps;
		const filteredOptions = teacherOptions.filter(option => {
			if (option.label === 'Morfofuncional' && !currUser?.MORFOFUNCIONAL) {
				return false;
			}
			if (!currUser?.TUTORIA) {
				if (option.label === 'Tutoria') return false;
				if (option.label === 'Cognitiva') return false;
				if (option.label === 'Notas Tutoria') return false;
				if (option.label === 'Desempenho Tutoria') return false;
				if (option.label === 'Autoavaliação e Interpares') return false;
			}
			return true;
		});
		return [...filteredOptions];
	} else if (user?.ENTRARCOMO === UserType.ALUNO) {
		return [...studentOptions];
	} else {
		return [];
	}
};

export const Drawer = ({ handleToggle, isOpen, user }: IDrawer) => {
	const { logout } = useAuthContext();

	const storage = new StorageManager();

	const handleClick = () => {
		storage.removeItem('selectedModule');
	};

	return (
		<DrawerChakra isOpen={isOpen} onClose={handleToggle} placement="left" colorScheme="primary.300">
			<DrawerOverlay>
				<DrawerContent color="neutral.0" background="primary.550">
					<DrawerBody
						ml="20px"
						my="20px"
						display="flex"
						flexDirection="column"
						height="100%"
						justifyContent="space-between"
					>
						<Box>
							<Box display="flex" mb="39px" onClick={handleToggle} cursor="pointer">
								<AiOutlineClose size={32} strokeWidth={3} />
							</Box>
							{!!user &&
								options(user).map((item, index) => (
									<Link to={item.link} key={index}>
										<Text sx={styles.textSide} key={index}>
											{item.label}
										</Text>
									</Link>
								))}
						</Box>

						<Box>
							{user?.ENTRARCOMO === UserType.ALUNO ? (
								<Link to={ROUTES.selectModule} onClick={handleClick}>
									<Text sx={styles.textFooter}>Alterar Módulo</Text>
								</Link>
							) : (
								<Link to={ROUTES.professorSelectPerlet} onClick={handleClick}>
									<Text sx={styles.textFooter}>Alterar Período Letivo</Text>
								</Link>
							)}
							<Box borderBottom="1px" borderColor="primary.250" />
							<Link to="#" onClick={() => logout()}>
								<Text sx={styles.textFooter} mt="15px">
									Sair
								</Text>
							</Link>
						</Box>
					</DrawerBody>
				</DrawerContent>
			</DrawerOverlay>
		</DrawerChakra>
	);
};
